import React, { useState } from 'react';

const FAQ = () => {
  const [activeItem, setActiveItem] = useState(null);

  const faqItems = [
    {
      id: 'faq-1',
      question: "How often should I have my home's exterior cleaned?",
      answer: "It depends on various factors including your location, surrounding environment, and personal preferences. Generally, we recommend a comprehensive exterior cleaning once or twice a year, with more frequent cleaning for specific areas that accumulate dirt faster."
    },
    {
      id: 'faq-2',
      question: "Are your cleaning solutions safe for plants and pets?",
      answer: "Yes, we use eco-friendly cleaning solutions that are safe for your plants, pets, and the environment. Our team takes extra precautions to protect your landscaping during the cleaning process."
    },
    {
      id: 'faq-3',
      question: "How long does a typical exterior cleaning service take?",
      answer: "The duration varies depending on the size of your property and the services you select. A standard exterior cleaning service for an average-sized home typically takes 4-6 hours. We'll provide you with a more accurate timeframe when you request a quote."
    },
    {
      id: 'faq-4',
      question: "Do I need to be home during the cleaning service?",
      answer: "No, you don't need to be home during the service as long as our team has access to the exterior areas that need cleaning. However, we're happy to accommodate your schedule if you prefer to be present."
    }
  ];

  const toggleItem = (itemId) => {
    setActiveItem(activeItem === itemId ? null : itemId);
  };

  return (
    <section className="faq" id="faq">
      <div className="faq-header animate-on-scroll">
        <h2>Frequently Asked Questions</h2>
        <p>Find answers to common questions about our services.</p>
      </div>
      <div className="faq-container">
        {faqItems.map((item) => (
          <div 
            key={item.id} 
            className={`faq-item animate-on-scroll visible ${activeItem === item.id ? 'active' : ''}`}
          >
            <div 
              className="faq-question"
              onClick={() => toggleItem(item.id)}
            >
              {item.question}
              <span>{activeItem === item.id ? '×' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
// /**
//  * FAQ Component
//  * Renders the FAQ section with expandable questions
//  */

// const FAQ = {
//   // FAQ data - could be moved to a separate data file
//   faqItems: [
//     {
//       id: 'faq-1',
//       question: "How often should I have my home's exterior cleaned?",
//       answer: "It depends on various factors including your location, surrounding environment, and personal preferences. Generally, we recommend a comprehensive exterior cleaning once or twice a year, with more frequent cleaning for specific areas that accumulate dirt faster."
//     },
//     {
//       id: 'faq-2',
//       question: "Are your cleaning solutions safe for plants and pets?",
//       answer: "Yes, we use eco-friendly cleaning solutions that are safe for your plants, pets, and the environment. Our team takes extra precautions to protect your landscaping during the cleaning process."
//     },
//     {
//       id: 'faq-3',
//       question: "How long does a typical exterior cleaning service take?",
//       answer: "The duration varies depending on the size of your property and the services you select. A standard exterior cleaning service for an average-sized home typically takes 4-6 hours. We'll provide you with a more accurate timeframe when you request a quote."
//     },
//     {
//       id: 'faq-4',
//       question: "Do I need to be home during the cleaning service?",
//       answer: "No, you don't need to be home during the service as long as our team has access to the exterior areas that need cleaning. However, we're happy to accommodate your schedule if you prefer to be present."
//     }
//   ],

//   render: () => {
//     // Create FAQ items HTML from the faqItems array
//     const faqItemsHtml = FAQ.faqItems.map(item => `
//       <div class="faq-item" id="${item.id}">
//         <div class="faq-question">
//           ${item.question}
//           <span>+</span>
//         </div>
//         <div class="faq-answer">
//           <p>${item.answer}</p>
//         </div>
//       </div>
//     `).join('');

//     return `
//       <section class="faq" id="faq">
//         <div class="faq-header">
//           <h2>Frequently Asked Questions</h2>
//           <p>Find answers to common questions about our services.</p>
//         </div>
//         <div class="faq-container">
//           ${faqItemsHtml}
//         </div>
//       </section>
//     `;
//   },

//   setup: () => {
//     // FAQ toggle functionality
//     const faqItems = document.querySelectorAll('.faq-item');
    
//     faqItems.forEach(item => {
//       const question = item.querySelector('.faq-question');
      
//       question.addEventListener('click', () => {
//         // Close all other items
//         faqItems.forEach(otherItem => {
//           if (otherItem !== item) {
//             otherItem.classList.remove('active');
//           }
//         });
        
//         // Toggle current item
//         item.classList.toggle('active');
//       });
//     });
//   }
// };

// export default FAQ;